export default __webpack_public_path__ + "static/media/favicon-blue-dot.733e004e.ico";